export const ARTICLE_LISTE_SUCCES = "ARTICLE_LISTE_SUCCES";
export const ARTICLE_LISTE_ECHEC = "ARTICLE_LISTE_ECHEC";
export const ARTICLE_LISTE_REQUETTE = "ARTICLE_LISTE_REQUETTE";

export const ARTICLE_LISTE_PROMO_SUCCES = "ARTICLE_LISTE_PROMO_SUCCES";
export const ARTICLE_LISTE_PROMO_ECHEC = "ARTICLE_LISTE_PROMO_ECHEC";
export const ARTICLE_LISTE_PROMO_REQUETTE = "ARTICLE_LISTE_PROMO_REQUETTE";

export const ARTICLE_FAMILLE_SUCCES = "ARTICLE_FAMILLE_SUCCES";
export const ARTICLE_FAMILLE_ECHEC = "ARTICLE_FAMILLE_ECHEC";
export const ARTICLE_FAMILLE_REQUETTE = "ARTICLE_FAMILLE_REQUETTE";

export const ARTICLE_MARQUE_SUCCES = "ARTICLE_MARQUE_SUCCES";
export const ARTICLE_MARQUE_ECHEC = "ARTICLE_MARQUE_ECHEC";

export const ARTICLE_FAMILLE_RESET = "ARTICLE_FAMILLE_RESET";
export const ARTICLE_DETAILS_REQUETTE = "ARTICLE_DETAILS_REQUETTE";
export const ARTICLE_DETAILS_SUCCES = "ARTICLE_DETAILS_SUCCES";
export const ARTICLE_DETAILS_ECHEC = "ARTICLE_DETAILS_ECHEC";

export const ARTICLE_DETAILS_RESET = "ARTICLE_DETAILS_RESET";

export const ARTICLE_TOUT_SUCCES = "ARTICLE_TOUT_SUCCES";
export const ARTICLE_TOUT_ECHEC = "ARTICLE_TOUT_ECHEC";

export const ARTICLE_TOUT_RESET = "ARTICLE_TOUT_RESET";

export const ARTICLE_CREE_SUCCES = "ARTICLE_CREE_SUCCES";
export const ARTICLE_CREE_ECHEC = "ARTICLE_CREE_ECHEC";
export const ARTICLE_CREE_RESET = "ARTICLE_CREE_RESET";
export const ARTICLE_CREE_REQUETTE = "ARTICLE_CREE_REQUETTE";

export const EVALUATION_REQUETTE = "EVALUATION_REQUETTE";
export const EVALUATION_SUCCES = "EVALUATION_SUCCES";
export const EVALUATION_ECHEC = "EVALUATION_ECHEC";
export const EVALUATION_RESET = "EVALUATION_RESET";

export const ARTICLE_LISTE_ALL_SUCCES = "ARTICLE_LISTE_ALL_SUCCES";
export const ARTICLE_LISTE_ALL_ECHEC = "ARTICLE_LISTE_ALL_ECHEC";

export const ARTICLE_NV_CREE_REQUETTE = "ARTICLE_NV_CREE_REQUETTE";
export const ARTICLE_NV_CREE_SUCCES = "ARTICLE_NV_CREE_SUCCES";
export const ARTICLE_NV_CREE_ECHEC = "ARTICLE_NV_CREE_ECHEC";
